<template>
  <div class="toggles">
    <button
      @click="updateViewStyle('tile')"
      :class="['toggles__view-btn', viewStyle === 'tile' && 'toggles__chosen']"
    >
      <ToggleTileView class="toggles__icon" />
    </button>
    <button
      @click="updateViewStyle('list')"
      :class="['toggles__view-btn', viewStyle === 'list' && 'toggles__chosen']"
    >
      <ToggleListView class="toggles__icon" />
    </button>
  </div>
</template>

<script>
import ToggleTileView from '@/assets/icons/search/toggle_tile_view.svg'
import ToggleListView from '@/assets/icons/search/toggle_list_view.svg'

export default {
  name: 'Toggles',
  props: {
    viewStyle: {
      type: String,
      required: true,
    },
  },
  components: {
    ToggleTileView: { ...ToggleTileView, name: 'ToggleTileView' },
    ToggleListView: { ...ToggleListView, name: 'ToggleListView' },
  },
  methods: {
    updateViewStyle(style) {
      this.$emit('update-view-style', style)
    },
  },
}
</script>

<style lang="scss" scoped>
.toggles {
  $this: &;
  &__view-btn {
    transition: 0.5s all ease;
    background: transparent;
    border: none;
    margin: 0 5px;
    padding: 0;
  }
  &__icon {
    fill: var(--white);
    &:hover {
      cursor: pointer;
      fill: var(--orange);
    }
  }
  &__chosen {
    &:after {
      content: '';
      display: block;
      width: 18px;
      height: 3px;
      background: var(--orange);
      position: absolute;
      margin: 11px 0 0 0;
    }
  }
}
</style>
